/**
 * 后台管理布局及其子页面
 * 按业务模块拆分到不同文件，再合并
 */
import settingRoutes from './setting'
import userRoutes from './users'
import profileRoutes from './profile'
import subscribeRoutes from './subscribe'
import cronRoutes from './cron'
import feedbackRoutes from './feedback'
import miniMenuRoutes from './miniMenu'

export default [
  {
    path: '/',
    component: () =>
      import(/* webpackChunkName: "layout" */ '@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      // 主页
      {
        path: 'admin/home',
        name: 'AdminHome',
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/DashboardView.vue'),
        meta: {
          requiresAuth: true,
          auth: 'home',
          title: '主页'
        }
      },
      // 403 无权限页面
      {
        path: '403',
        name: 'Forbidden',
        component: () =>
          import(/* webpackChunkName: "forbidden" */ '@/views/ForbiddenView.vue'),
        meta: {
          requiresAuth: true,
          skipPermission: true,
          title: '暂无权限'
        }
      },
      // 设置模块路由（展开所有子路由）
      ...settingRoutes,
      // 用户管理模块路由（展开所有子路由）
      ...userRoutes,
      // 个人信息模块路由
      ...profileRoutes,
      // 订阅消息模板管理模块路由
      ...subscribeRoutes,
      // 定时任务管理模块路由
      ...cronRoutes,
      // 意见反馈模块路由
      ...feedbackRoutes,
      // 小程序菜单管理模块路由
      ...miniMenuRoutes
    ]
  }
]
